import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-show-services-dialog',
  templateUrl: './show-services-dialog.component.html',
  styleUrls: ['./show-services-dialog.component.css']
})
export class ShowServicesDialogComponent implements OnInit {

  Services
  ServiceValue
  doctor

  
  constructor(
    public dialog: MatDialogRef<ShowServicesDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public services: any,
    public translate: TranslateService,
    public app : AppService
  ) { }

  ngOnInit(): void {
    this.Services = this.services?.res 
    this.doctor = this.services?.doctorId
  }

  save = () => { 

  }

}
